// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ProgramModel {
    'tenantId'?: number;
    'programId'?: number;
    'programNumber'?: number;
    'programTypeCode'?: string;
    'programTypeId'?: number;
    'programName'?: string;
    'programDesc'?: string;
    'programStartDate'?: Moment;
    'programEndDate'?: Moment;
    'programCreateDate'?: Moment;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ProgramModel>> = [
        {
            "name":     "tenantId",
            "baseName": "tenantId",
            "type":     "number"
        },
        {
            "name":     "programId",
            "baseName": "programId",
            "type":     "number"
        },
        {
            "name":     "programNumber",
            "baseName": "programNumber",
            "type":     "number"
        },
        {
            "name":     "programTypeCode",
            "baseName": "programTypeCode",
            "type":     "string"
        },
        {
            "name":     "programTypeId",
            "baseName": "programTypeId",
            "type":     "number"
        },
        {
            "name":     "programName",
            "baseName": "programName",
            "type":     "string"
        },
        {
            "name":     "programDesc",
            "baseName": "programDesc",
            "type":     "string"
        },
        {
            "name":     "programStartDate",
            "baseName": "programStartDate",
            "type":     "Date"
        },
        {
            "name":     "programEndDate",
            "baseName": "programEndDate",
            "type":     "Date"
        },
        {
            "name":     "programCreateDate",
            "baseName": "programCreateDate",
            "type":     "Date"
        },
    ];

    static getAttributeTypeMap() {
        return ProgramModel.attributeTypeMap;
    }
}
